<template>
  <modal @before-open="beforeOpen" @opened="opened" name="messageDetail" :draggable="'.header'" :reset="true" :classes="['messageDetail','generalbox']" :adaptive="true"
          :height="'80%'" :width="'80%'" :max-width="1540" :max-height="885" :min-width="1092"
         :min-height="614" :click-to-close="false">
    <div @click="close" class="close">
      <i class="iconfont icon-cha"></i>
    </div>
    <div class="header">
      <h2>消息详情</h2>
    </div>
    <div class="content">
      <h3>{{data.title}}</h3>
      <p>{{data.time}}</p>
      <p v-if="getModuleNameByType">本消息来自：{{getModuleNameByType}}<button @click="toDetail" class="toDetail">点击进入{{getModuleNameByType}}</button></p>
      <div>{{data.content}}</div>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';

  export default {
    name: "messageDetail",
    data() {
      return {
        data:{}
      }
    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.$modal.hide("messageDetail");
      },
      beforeOpen(data){
        this.data=data.params;
      },
      opened(){
        this.updateModalZIndex(this.$el)
      },
      toDetail(){
        let modalName="";
        switch (this.data.type) {
          case 1:
            modalName='schedule'
            break
          case 2:
            modalName='message'
            break
          case 3:
            modalName='notice'
            break
          case 4:
            modalName='todo'
            break
          default:
            return 0
        }
        this.$modal.show(modalName,{})
      }
    },
    computed: {
      getModuleNameByType(){
        switch (this.data.type) {
          case 1:
            return '日程'
          case 3:
            return '通知公告'
          case 4:
            return '事项'
          default:
            return 0

        }
      }
    },
    mounted() {},
    components: {}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
.content
  &>h3
    margin-top 20px
    font-size 16px
    text-align center
    line-height 50px
    color #666666
  &>p
    font-size 14px
    text-align center
    line-height 30px
    color #666666
    &>.toDetail
      width 100px
      font-size 12px
      color #666666
      height 26px
      border 1px solid #cccccc
      border-radius 5px
      background none
      margin-left 20px
      outline none
      transition 300ms
      &:hover
        background-color #eeeeee
  &>div
    padding 20px
    text-indent 2em
    color #666666
    line-height 25px
    font-size 14px
</style>


// WEBPACK FOOTER //
// src/components/message/messageDetailModal.vue